// extracted by mini-css-extract-plugin
export var fileUpload = "_jb-1";
export var modalButton = "_jb-0";